import React, { useEffect, useState } from 'react';
import './../../pg/Global.css';
import './../Palette.css';
import './ProjectsViewer.css';
import { useSearchParams } from 'react-router-dom';

export type Project = {
    Title: string,
    WorkName: string,
    DescShort: string,
    Link: string,
    PromoImg: string,
    PromoGif: string | null,
};

type ProjectsViewerParms = {
    Projects: Project[],
};

const ProjectsViewer: React.FC<ProjectsViewerParms> = ({ Projects }) => {
    const [searchParams, _setSearchParams] = useSearchParams();
    const [lang, setLang] = useState('en');

    useEffect(() => {
        const searchLang = searchParams.get("lang");
        if (searchLang != null && searchLang !== lang) {
            setLang(searchLang);
        }
    }, []);
    return (
        <div className='ProjectsViewerWrapper'>
            <div className='ProjectsViewerGrid'>
                {
                    Projects.map((param) => {
                        const url = `/#projects/${param.Link[0] === '/' ? '' : param.Link}/?lang=${lang}`;
                        return (
                            <div className='Project' key={param.WorkName}>
                                {
                                    param.PromoGif == null ?
                                        <img className='ProjectImgWrap' src={'/' + param.PromoImg} /> :
                                        <div className='ProjectImgWrap'>
                                            <img className='ProjectActive' src={'/' + param.PromoGif} />
                                            <img className='ProjectStatic' src={'/' + param.PromoImg} />
                                        </div>
                                }
                                <div className='ProjectWrap'>
                                    <div className='ProjectRow ProjectTitle'>
                                        <h2>{param.Title}</h2>
                                    </div>
                                    <div className='ProjectRow ProjectDesc'>
                                        <a>{param.DescShort}</a>
                                    </div>
                                    <div className='ProjectRow ProjectLink'>
                                        <a href={url}>Go to details...</a>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default ProjectsViewer;

